<template>
  <div>

    <div id="preview">
      <img :src="results['logofile']" />
    </div>

    <section>  
      <h2> Setup your administrator user </h2>

      <hr />

      <b-container class="bv-example-row">

        <b-row>

          <b-col cols="8">
          
            <b-form>

              <label><strong>Name</strong></label>
              <b-input-group v-bind:class="{ 'has-error': $v.full_name.$error }">
                <b-form-input
                  id="fullnameinput"
                  name="fullnameinput"
                  v-model.trim="full_name" @input="$v.full_name.$touch()"
                  :state="validateState('full_name')"
                  aria-describedby="name-live-feedback"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="name-live-feedback"
                >Please enter a valid user name.</b-form-invalid-feedback>
              </b-input-group>

              <label class="mt-3"><strong>Email</strong></label>
              <b-input-group v-bind:class="{ 'has-error': $v.user_email.$error }">
                <b-input-group-prepend is-text>
                  <b-icon icon="envelope"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  id="useremailinput"
                  name="useremailinput"
                  type="email"
                  v-model.trim="user_email" @input="$v.user_email.$touch()"
                  :state="validateState('user_email')"
                  aria-describedby="useremail-live-feedback"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="useremail-live-feedback"
                >Please enter a valid email address.</b-form-invalid-feedback>
              </b-input-group>
                <b-form-text>
                  An activation email will be sent to this email address. Make sure this email address is valid.
                </b-form-text>

            </b-form>
          
          </b-col>

          <b-col cols="4">
            <b-img :src="require('./assets/images/slide-01.png')" fluid alt="smartbox smartbilling"></b-img>
          </b-col>
      
        </b-row>
  
      </b-container>

    </section>

  </div>

</template>

<script>

const { required, email, minLength, maxLength } = require('vuelidate/lib/validators')
const { default: Vuelidate } = require('vuelidate')
import BIcon from 'bootstrap-vue'
import { helpers } from 'vuelidate/lib/validators'

const alphablank = helpers.regex('alpha', /^[a-zA-Z0-9 ]*$/)

export default {
  name: 'StepUser',
  props: ['results'],
  data() {
    return {
      full_name: '',
      user_email: ''
    }
  },
  validations: {
    full_name: {
      required,
      alphablank,
      minLength: minLength(3),
      maxLength: maxLength(30)      
    },
    user_email: {
      required,
      email
    },
    form: ['full_name', 'user_email']
  },
  methods: {
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid
      this.$emit('on-validate', this.$data, isValid)
      return isValid
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/StepUser.vue